import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, Form, message, Row, Col } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const FormItem = Form.Item;
const dateFormat = 'YYYY-MM-DD';

class CreateForm extends Component {
    render() {
        const { params = {}, form: { getFieldDecorator } } = this.props;
        const { userCompellation, employeeCode } = params;
        const formItemLayout = {
            labelCol: {
                sm: { span: 7 },
                md: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
                md: { span: 16, offset: 1 },
            },
        };
        return (
            <Form>
                <FormItem {...formItemLayout} label="人员">
                    {`${userCompellation}[${employeeCode}]`}
                </FormItem>
                <FormItem {...formItemLayout} label="获得荣誉时间">
                    {
                        getFieldDecorator('awardTime', {
                            rules: [{
                                required: true,
                                message: '请选择获得荣誉时间'
                            }],
                        })(
                            <DatePicker placeholder="请选择" style={{width:220}} />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="获得荣誉层面">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('awardLevel', {
                                    rules: [{
                                        required: true,
                                        message: '请选择获得荣誉层面'
                                    }]
                                })(
                                    <Select
                                        placeholder="请选择"
                                        style={{width:220}}
                                    >
                                        <Option value="COMPANY">公司层面</Option>
                                        <Option value="INVESTIGATION">项目层面</Option>
                                    </Select>
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label="获得荣誉说明">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('awardComments', {
                                    rules: [{
                                        required: true,
                                        message: '请输入获得荣誉说明'
                                    }]
                                })(
                                    <Input style={{ width: 220 }} placeholder="请输入" />
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label="获得荣誉类型">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('awardType', {
                                    rules: [{
                                        required: true,
                                        message: '请选择获得荣誉类型'
                                    }]
                                })(
                                    <Select
                                        placeholder="请选择"
                                        style={{width:220}}
                                    >
                                        <Option value="CERTIFICATE_MERIT">奖状</Option>
                                        <Option value="TROPHY">奖杯</Option>
                                        <Option value="CERTIFICATE_HONOR">荣誉证书</Option>
                                    </Select>
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

class UpdateHonorRecord extends Component {
    state = {
        params: {},
        visible: false,
        confirmLoading: false,
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => { 
        this.setState({
            visible: false
        });
    }

    confirm = () => {
        this.formRef.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const { awardTime } = values;
            const { isEdit, params } = this.state;
            const { userId, pmAwardId } = params;

            this.setState({ confirmLoading: true });
            const url = isEdit ? API_URL.user.editPmAward : API_URL.user.addPmAward;

            const options = {
                method: 'POST',
                url,
                data: {
                    ...values,
                    userId,
                    pmAwardId,
                    awardTime: moment(awardTime).format(dateFormat),
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.setState({ confirmLoading: false }, () => {
                        this.props.loadData(userId);
                    });
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                },
            }
            $.sendRequest(options);
        });
    }

    render() {
        const { isEdit, confirmLoading, visible, params } = this.state;
        const newProps = {};
        const objArr = Object.entries(params);
        objArr.forEach((arr) => {
            if (arr[0] == 'awardTime') {
                newProps[arr[0]] = {
                    value: arr[1] ? moment(arr[1]) : null,
                };
            } else {
                newProps[arr[0]] = {
                    value: arr[1],
                };
            }
        });
        const mapPropsToFields = () => ({
            ...newProps,
        });
        const CreateForms = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}荣誉记录`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                confirmLoading={confirmLoading}
                maskClosable={false}
                width={550}
            >
                <div style={{ margin: '10px 0' }}>
                    <CreateForms
                        params={params}
                        isEdit={isEdit}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default UpdateHonorRecord;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/UpdateHonorRecord.js